module.exports = __webpack_public_path__ + "static/media/blue.788ee8ee.svg";